import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import DataTable from "../../components/dataTables/DataTable";
import { useContext, useState } from "react";
import { useUsers } from "../../hooks";
import { buildColDefs } from "../../components/dataTables/buildColDefs";
import { User } from "../../data-parsing/users/User";
import { CreationForm, CreationFormTemplate } from "../../components/form/CreationForm";
import { AddUserFormTemplate } from "../../data-parsing/users/FormTemplate";
import { ResponseStatus, StatusContextApi } from "../../context/status";
import { getKeyByValue } from "../../data-parsing/parseUtils";
import { InputTypes } from "../../data-parsing/InputTypes";


export function Users() {
    const [query] = useState(0);
    const { users, createUser, deleteUser, updateUser } = useUsers(query);
    const { addMessage } = useContext(StatusContextApi);



    let isNutritionist = sessionStorage?.getItem("doctor") === "true" || false;
    //Disallow nutritionists to delete users
    let colDefs = buildColDefs(User);
    colDefs = isNutritionist ? colDefs.filter((e) => {
        return !(e.type === InputTypes.DELETE)
    }) : colDefs



    function validateFields(formData) {
        if (formData.get(getKeyByValue(User, User.password)) !== formData.get(getKeyByValue(User, User.passwordVerification))) {
            addMessage(ResponseStatus.ERROR, 5000, "Los valores de contraseña introducidos no coinciden");
            return false;
        }
        return true;
    }

    return <LeftSideMenu active="users">
        <div id="wrapper">
            <div className="container">
                <div className="row">

                    <div className="col-xs-12">
                        <div className="card-box card-tabs m-t-20">
                            <h4 className="header-title m-t-0 m-b-30 pull-right">USUARIOS</h4>
                            <ul className="nav nav-pills">
                                <li id="liTabViewUsers" className="active">
                                    <a href="#tabViewUsers" data-toggle="tab" aria-expanded="false"><i
                                        className="far fa-eye"></i> LISTAR USUARIOS</a>
                                </li>
                                <li id="liTabAddUsers">
                                    <a href="#tabAddUsers" data-toggle="tab" aria-expanded="true"><i
                                        className="fas fa-plus-circle"></i> NUEVO USUARIO</a>
                                </li>
                            </ul>
                            <div className="tab-content">
                                <div id="tabAddUsers" className="tab-pane">
                                    <div className="row">
                                        <CreationForm createFunction={createUser} validateForm={validateFields}>
                                            <CreationFormTemplate formTemplate={AddUserFormTemplate}
                                                dataTemplate={User} />
                                            <div className="col-sm-12">
                                                <button className="btn btn-rounded btn-purple m-t-20 ml-10">
                                                    <i className="far fa-save"></i> Guardar
                                                    Usuario
                                                </button>
                                            </div>
                                        </CreationForm>
                                    </div>
                                </div>
                                <div id="tabViewUsers" className="tab-pane fade in active">
                                    <DataTable colDefs={colDefs} data={users} dataId={"Users"} resizable={true}
                                        allowHiddenColumns={false} scrollX={false} editElement={updateUser}
                                        className="table table-bordered panel-group" deleteElement={deleteUser} />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </LeftSideMenu>
}